module.exports = __webpack_public_path__ + "media/Extremely_high_danger_of_collision.b38f521f.mp4";